module.exports = __webpack_public_path__ + "static/media/youtube.26be207c.svg";